import providerProfileTransformer from '../transformers/providerProfile';
import patienProfileTransformer from '../transformers/patientProfile';
import arrayUtil from '../utils/arrayUtil';
import loader from '../utils/loader';
export default {
  data: () => ({}),
  computed: {},
  methods: {
    providerName(provider) {
      return providerProfileTransformer.fullName(provider);
    },
    patientName(patient) {
      return patienProfileTransformer.fullName(patient);
    },
    patientUserName(patient) {
      if (patient.display_name) return `${patient.display_name}<br>`;
      else return '';
    },
    patientOrganization(organization) {
      if (organization && organization.name) return `<br>${organization.name}`;
      else return '';
    },
    contact(user) {
      let content = '';
      if (user.email) content += '<br>Email: ' + user.email;
      if (user.tel) content += `<br>Tel: <a href="tel: ${user.tel}">${user.tel}</a>`;
      if (user.support_pin) content += `<br>Support Pin: <strong>${user.support_pin}</strong>`;
      return content;
    },
    reserved_duration(appointment) {
      let content = appointment.reserved_duration;
      if (appointment.extension_duration) {
        content += '+' + appointment.extension_duration;
      }
      return content;
    },
    changeStatusFromCancel(id) {
      let index = window._.indexOf(this.appointments, window._.find(this.appointments, { id: id }));
      this.appointments[index].status = 'cancelled';
    },
    showNewDueDate(newData) {
      this.appointments = arrayUtil.searchByIdentityAndChangeAnyValue(
        this.appointments,
        { id: newData.id },
        { appointed_at: newData.appointed_at }
      );
    },
    showNewStatus(newData) {
      this.appointments = arrayUtil.searchByIdentityAndChangeAnyValue(
        this.appointments,
        { id: newData.id },
        { status: newData.status }
      );
    },
  },
  created() {},
  components: {
    AppointmentTypeIcon: loader.component('AppointmentTypeIcon'),
    ContactUser: loader.component('ContactUser'),
    CancelAppointment: loader.component('CancelAppointment'),
    ChangeAppointmentDueDate: loader.component('ChangeAppointmentDueDate'),
    ChangeAppointmentStatus: loader.component('ChangeAppointmentStatus'),
    AppointmentUserAnalytic: loader.component('AppointmentUserAnalytic'),
  },
};
